import React, { useEffect } from 'react'

const DefaultContainer = () => {

  useEffect(() => {
      window.location.replace("/CB_500")
}, [])

  return (
    <div>Valid Component is not mapped for this page!</div>
  )
}

export default DefaultContainer